import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CCDASearchPatientComponent } from 'src/app/ChildControls/ccdasearch-patient/ccdasearch-patient.component';
import { IPatientDetails } from 'src/app/models/IEPrescriptionXMLDTO';
import { PatientSearchComponent } from 'src/app/patient-search/patient-search.component';
import { AuditLog } from 'src/app/models/iauditlog.model';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { CCDAService } from '../ccda.service';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { Defaults } from 'src/app/Utilities/defaults';
declare var $: any;
@Component({
  selector: 'app-genarate-ccda',
  templateUrl: './genarate-ccda.component.html',
  styleUrls: ['./genarate-ccda.component.css'],
  // encapsulation: ViewEncapsulation.None
})
export class GenarateCCDAComponent implements OnInit {
  CDADataExport: FormGroup;
  PatientDetails: any = [];
  ProviderDetails: any = [];
  ProvidersDataList: any = [];
  patientSelectList: any[] = [];
  PatSelected: any;
  patientName: any;
  PatientistId: number[];
  PatientistId_Master: number[];
  disabledRunExport: boolean = false;
  ProviderSelectList: any[] = [];
  ProviderSelectedList: any[] = [];
  ProviderSelected: any;
  ProviderName: any;
  ProviderListId: number[];
  ProviderListId_Master: number[];

  constructor(private _formBuilder: FormBuilder, private toastr: ToastrService,
    private _datePipe: DatePipe, private _toastr: ToastrService,
    private spinner: NgxSpinnerService, public dialog: MatDialog,
    private _ccdaService: CCDAService, private sharedService: SharedService) { }

  ngOnInit() {
    $('#ccdaPatientfocus').on('focus', function () {
      $('#ccdaPatienthide').show();
    });
    $('#ccdaProviderfocus').on('focus', function () {
      $('#ccdaProviderhide').show();
    });
    this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
      this.ProviderDetails = data;
      this.ProvidersDataList = data;
      var res = ''
      this.ProviderListId = [];
      this.ProviderDetails.forEach(c => {
        if (c != '') {
          this.ProviderListId.push(c.userId);
          if (res == '') {
            res = c.fullName;
            c.selected = true;
          }
          else {
            res += ", " + c.fullName;
            c.selected = true;
          }
        }
        this.CDADataExport.patchValue({
          IsProviderCheck: true
        });
      })


      this.CDADataExport.controls["ProviderList"].setValue(res);
      //this.checkDefaultProvider();
    });
    $(document).click(function (event) {
      if (event.target.id != "ccdaPatientfocus") {
        var container = $("#ccdaPatienthide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }
      else
        $('#ccdaPatienthide').show();
      if (event.target.id != "ccdaProviderfocus") {
        var container = $("#ccdaProviderhide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }
      else
        $('#ccdaProviderhide').show();
    });

    /*
    $(document).click(function (event) {

      if (event.target.id != "ccdaPatientfocus") {
        var container = $("#ccdaPatienthide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      } else {
        $('#ccdaPatienthide').show();
      }
    });
*/
    var date = this._datePipe.transform(new Date(), "yyyy-MM-dd")
    var time = this._datePipe.transform(new Date(), "HH:mm")
    this.CDADataExport = this._formBuilder.group({
      Occurance: ['Once', [Validators.required]],
      RecurringFrom: [date, [Validators.required]],
      RecurringTo: [date, [Validators.required]],
      PatientType: ['All'],
      PatientList: [''],
      ExportType: ['Now', [Validators.required]],
      ExportDate: [date],
      ExportTime: [time],
      RecurringType: ['Monthly'],
      RecurringDate: [date],
      ProviderType: ['Select'],
      ProviderList: [''],
      IsProviderCheck: [''],
    });
    this.PatientType_radioChange();
    this.AuditLogs("USP_EMR_PATIENT_INFORMATION_GETBYDATE", 'ccda');
  }
  fnclear() {
    var date = this._datePipe.transform(new Date(), "yyyy-MM-dd")
    var time = this._datePipe.transform(new Date(), "HH:mm")
    this.CDADataExport.reset();
    this.CDADataExport.patchValue({
      Occurance: 'Once',
      RecurringFrom: date,
      RecurringTo: date,
      PatientType: 'All',
      PatientList: '',
      ExportType: 'Now',
      ExportDate: date,
      ExportTime: time,
      RecurringType: 'Monthly',
      RecurringDate: date,
      ProviderType: 'All',
      ProviderList: '',
    })
    this.PatientistId = [];
    this.ProviderListId = [];
    this.PatientistId_Master = [];
    this.ProviderListId_Master = [];
    this.ToSelectUsers = [];
  }
  fnsaveData() {
    if (this.CDADataExport.value.PatientList == undefined
      || this.PatientistId == undefined || this.PatientistId.length == 0) {
      this._toastr.error("No Selected Patients");
      return;
    }
    if (this.CDADataExport.value.Occurance == 'Once') {
      this.CDADataExport.controls["RecurringType"].setValue('');
      this.CDADataExport.controls["RecurringDate"].setValue('');
      this.CDADataExport.controls["ProviderType"].setValue('');
      this.CDADataExport.controls["ProviderList"].setValue('');
    }
    else if (this.CDADataExport.value.Occurance == 'Recurring') {
      this.CDADataExport.controls["ExportType"].setValue('');
      this.CDADataExport.controls["ExportDate"].setValue('');
      this.CDADataExport.controls["ExportTime"].setValue('');
    }

    if (this.CDADataExport.value.PatientType == 'All') {
      this.CDADataExport.value.PatientList = this.PatientistId = this.PatientistId_Master;
    }
    if (this.CDADataExport.value.ProviderType == 'All') {
      this.ProviderListId = this.ProviderListId_Master;
    }
    if (this.PatientistId)
      this.CDADataExport.value.PatientList = this.PatientistId;

    if (this.ProviderListId)
      this.CDADataExport.value.ProviderList = this.ProviderListId.join(',');
    else
      this.CDADataExport.value.ProviderList = '';
    this.spinner.show();
    this._ccdaService.AddClinicalDataExport_CDA(this.CDADataExport.value).subscribe(result => {
      this._toastr.success(result);
      this.fnclear();
      this.spinner.hide();
    },
      (err: any) => { console.log(err); this.spinner.hide(); }
    )
  }
  public providersList: IUserDetails[];
  checkAllORSelect: boolean = false;
  PatientType_radioChange() {
    this.CDADataExport.controls["PatientList"].setValue("");
    this.ToSelectUsers = [];
    this.PatientistId = [];
    this.PatientistId_Master = this.PatientistId = this.PatientDetails = [];
    let event_Value = this.CDADataExport.controls["PatientType"].value;
    let Occurance = this.CDADataExport.controls["Occurance"].value;
    var date = this._datePipe.transform(new Date(), "yyyy-MM-dd");
    var recfrom = '';
    var recto = '';
    this.disabledRunExport = true;
    if (Occurance == 'Once' && event_Value == 'Select') {
      this.checkAllORSelect = true;
      if (this.CDADataExport.controls["RecurringFrom"].value == null && this.CDADataExport.controls["RecurringTo"].value == null) {
        this.CDADataExport.patchValue({
          RecurringFrom: date,
          RecurringTo: date
        });
      }

      recfrom = this.CDADataExport.controls["RecurringFrom"].value;
      recto = this.CDADataExport.controls["RecurringTo"].value;
      if (!recfrom)
        return
      // {
      //   recfrom=date;
      //   this.CDADataExport.controls["RecurringFrom"].setValue(recfrom);
      // }
      if (!recto) {
        recto = date;
        this.CDADataExport.controls["RecurringTo"].setValue(recto);
      }
    }
    if (Occurance == 'Recurring') {
      this.CDADataExport.controls["RecurringFrom"].setValue('');
      this.CDADataExport.controls["RecurringTo"].setValue('');
    }
    if (event_Value == 'All') {
      this.checkAllORSelect = false;
      this.disabledRunExport = false;
    }
    if (Occurance == 'Once' && event_Value == 'All') {
      if (this.CDADataExport.controls["RecurringFrom"].value == null && this.CDADataExport.controls["RecurringTo"].value == null) {
        this.CDADataExport.patchValue({
          RecurringFrom: date,
          RecurringTo: date
        });
      }
      recfrom = this.CDADataExport.controls["RecurringFrom"].value;
      recto = this.CDADataExport.controls["RecurringTo"].value;
    }
    //this.spinner.show();
    if(event_Value != 'Select')
    this._ccdaService.GetPatientDetailsByDate(recfrom, recto).subscribe(result => {
      this.PatientDetails = result;
      if (this.PatientDetails != null && this.PatientDetails.length > 0) {
        var res = ''
        this.PatientistId = [];
        const patientnames = this.PatientDetails.map(x => x.fullName).join(',');
        this.PatientistId_Master = this.PatientistId = this.PatientDetails.map(x => x.patientId);
        this.PatientDetails.map(x => x.selected = true);
        // this.PatientDetails.forEach(x => { x.selected = true });
        /*  this.PatientDetails.forEach(c => {
            if (c != '') {
              if (res == '') {
                res = c.fullName;
                c.selected = true;
              }
              else {
                res += ", " + c.fullName;
                c.selected = true;
              }
              this.PatientistId.push(c.patientId);
            }
          })
          */
        // this.PatientistId_Master = this.PatientistId;
        if (this.checkAllORSelect == true) {
          this.PatientistId = [];
        }
        this.CDADataExport.controls["PatientList"].setValue(patientnames);

        //this.PatientSelectionChanged(null);
      }
      this.spinner.hide();
    }, (error) => { this.spinner.hide(); })

  }

  PatientSelectionChanged(list) {
    this.PatientistId = [];
    this.patientSelectList = list.selectedOptions.selected.map(item => item.value);
    this.PatSelected = '';
    this.patientName = '';
    for (let index = 0; index < this.patientSelectList.length; index++) {
      // this.PatSelected += this.patientSelectList[index].patientId + ',';
      this.patientName += this.patientSelectList[index].fullName + ', ';
      this.PatientistId.push(Number(this.patientSelectList[index].patientId))
    }
    if (this.patientSelectList.length != 0) {
      this.patientName = this.patientName.substring(0, this.patientName.length - 2);
    }
    this.CDADataExport.patchValue({
      PatientList: this.patientName
    })
  }


  ProviderSelectionChanged(list) {
    this.ProviderListId = [];
    this.ProviderSelectList = list.selectedOptions.selected.map(item => item.value);
    this.ProviderSelected = '';
    this.patientName = '';
    for (let index = 0; index < this.ProviderSelectList.length; index++) {
      this.patientName += this.ProviderSelectList[index].fullName + ', ';
      this.ProviderListId.push(Number(this.ProviderSelectList[index].userIdentity))
      this.ProviderSelectList[index].selected = true;
    }
    if (this.ProviderSelectList.length != 0) {
      this.patientName = this.patientName.substring(0, this.patientName.length - 2);
      this.disabledRunExport = false;
    } else {
      this.disabledRunExport = true;
    }
    this.ProviderListId_Master = this.ProviderListId;
    this.CDADataExport.patchValue({
      ProviderList: this.patientName
    })
    this.checkDefaultProvider();
  }
  onSelectionChanged(event, type: string) {
    setTimeout(() => {
      if (event !== null && event !== undefined) {
        $(event.target).prev().trigger('focus');
        if (type == 'PatientList') {
          $('#ccdaPatientfocus').on('focus', function () {
            $('#ccdaPatienthide').show();
          });
        }
        else if (type == 'ProviderList') {
          $('#ccdaProviderfocus').on('focus', function () {
            $('#ccdaProviderhide').show();
          });
        }

      }
    }, 100);
  }

  focusOutFunction(evn, type) {
    if (type == 'PatientList') {
      if (evn.keyCode === 9) {
        $('#ccdaPatienthide').hide()
      } else if (evn.keyCode === 40 && evn.target.id == "ccdaPatientfocus") {
        $('#patientntlistoption0').focus();
      }
    }
    else {
      if (evn.keyCode === 9) {
        $('#ccdaProviderhide').hide()
      } else if (evn.keyCode === 40 && evn.target.id == "ccdaProviderfocus") {
        $('#ProviderListoption0').focus();
      }
    }

  }

  CCSelectUsers: any = [];
  ToSelectUsers: any = [];
  onClickPatientSearch() {
    this.CDADataExport.controls["PatientList"].setValue("");
    var fromdata = this.CDADataExport.controls["RecurringFrom"].value;
    var todate = this.CDADataExport.controls["RecurringTo"].value;
    sessionStorage.setItem("ispatSerachPopup", "True");
    const dialogRef = this.dialog.open(CCDASearchPatientComponent, {
      width: 'auto',

      data: { fromDate: fromdata, toDate: todate }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && result != '') {
        let PatIdObj: any = {
          patientId: result.patientId,
        }
        this.PatientistId.push(result.patientId);
        if (this.ToSelectUsers.some(x => x.name == result.name)) {
          this.toastr.warning('This user already added')
          return;
        } else {
          let toObj: any = {
            name: result.name,
          }
          this.disabledRunExport = false;
          this.ToSelectUsers.push(toObj);
        }
      }
    });
  }


  RemoveUser(index: number) {
    this.ToSelectUsers.splice(index, 1);
    this.PatientistId.splice(index, 1);
    if (this.ToSelectUsers.length == 0) {
      this.disabledRunExport = true;
    }
  }
  public _auditLog: AuditLog;
  AuditLogs(sp: any, input: any) {
    this._auditLog = new AuditLog();
    this._auditLog.InputParameters = input;
    this._auditLog.SPName = sp;
    this.sharedService.selectCopyPrintAuditLog(this._auditLog).subscribe(async result => {
      await result;
    });
  }


  selectedproviderArray: string[] = [];
  public providernames: string = '';
  public provselected: string = '';
  checkSelectAllProviders(event, schstr) {
    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    if (ischk == true) {
      this.provselected = '';
      this.providernames = '';
      this.selectedproviderArray = [];
      this.ProviderDetails = this.ProvidersDataList;
      this.ProviderDetails.filter(x => x.selected = false);
      for (let index = 0; index < this.ProviderDetails.length; index++) {
        this.providernames += this.ProviderDetails[index].fullName + '; ';
        this.provselected += this.ProviderDetails[index].userIdentity + ',';
        this.ProviderDetails[index].selected = true;
        this.selectedproviderArray.push((this.ProviderDetails[index].userIdentity).toString());
      }
      if (this.ProviderDetails.length != 0) {
        this.providernames = this.providernames.substring(0, this.providernames.length - 2);
        this.CDADataExport.patchValue({
          ProviderList: this.providernames,
        })
      }
      else {
        this.CDADataExport.patchValue({
          ProviderList: ''
        })
      }
      this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
        this.ProviderDetails = data;
        this.ProvidersDataList = data;
        var res = ''
        this.ProviderListId = [];
        this.ProviderDetails.forEach(c => {
          if (c != '') {
            this.ProviderListId.push(c.userId);
            if (res == '') {
              res = c.fullName;
              c.selected = true;
            }
            else {
              res += ", " + c.fullName;
              c.selected = true;
            }
          }
          this.CDADataExport.patchValue({
            IsProviderCheck: true
          });
        })
      })
    } else {
      for (let index = 0; index < this.ProviderDetails.length; index++) {
        this.ProviderDetails[index].selected = false;
      }
      this.provselected = '';
      this.providernames = '';
      if (this.ProviderDetails.length != 0) {
        this.providernames = this.providernames.substring(0, this.providernames.length - 2);
        this.CDADataExport.patchValue({
          ProviderList: this.providernames,
        })
      }
      else {
        this.CDADataExport.patchValue({
          ProviderList: ''
        })
      }
      this.disabledRunExport = true;
    }
  }

  checkDefaultProvider() {
    if (this.ProviderDetails.length > 0 && this.ProviderDetails != undefined) {
      var selectProvlst = this.ProviderSelectList.filter(x => x.selected == true);
      if (selectProvlst.length === this.ProvidersDataList.length) {
        this.CDADataExport.patchValue({
          IsProviderCheck: true
        });
      } else {
        this.CDADataExport.patchValue({
          IsProviderCheck: false
        });
      }
    } else {
      this.CDADataExport.patchValue({
        IsProviderCheck: false
      });
    }
  }
}
